import { toValue } from 'vue'
import { whenever } from '@/utils/utils'
import { set as _set } from 'lodash'

export default function pipelinesStore ({ store }) {
  store.$pipeline = async ({ default_value, resource, dependencies = [] }) => {
    if (default_value && resource) setDefaultvalue({ resource, default_value })
    if (dependencies.length) await waitForDependencies(dependencies)

    return {
      resource: toValue(resource)
    }
  }

  async function waitForDependencies (dependencies) {
    await new Promise(resolve => {
      whenever(
        () => dependencies.every(dependency => !!toValue(dependency)),
        resolve,
        { immediate: true }
      )
    })
  }

  function setDefaultvalue ({ resource, default_value }) {
    _set(store.$state, `${toValue(resource)}.item`, default_value)
    _set(store.$state, `${toValue(resource)}.status`, 'success')
  }
}